import { Component, OnInit, Input, ViewChild, ElementRef, HostListener, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { LiveEventViewModel, UserAuthenticationViewModel, ChatHistoryViewModel, LobbyViewModel } from 'src/app/_models/generatedModels';
import { HubConnection } from '@microsoft/signalr';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { ChatViewModel } from 'src/app/_models/models';
import { of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { EventService, LobbyService } from 'src/app/_services/generatedServices';

@Component({
  selector: 'bxl-lobby-chat',
  templateUrl: 'lobby-chat.component.html',
})
export class LobbyChatComponent implements OnInit {
  initialized = false;
  @Input() lobby: LobbyViewModel;
  @Input() connection: HubConnection;
  @ViewChild('messageContainer') private messageContainer: ElementRef;
  @ViewChild('chatbox') private chatbox: ElementRef;

  public user: UserAuthenticationViewModel;
  public messages: ChatViewModel[] = new Array();
  public exisitingMessages: ChatHistoryViewModel[] = new Array();
  public chatMessage: string;
  toggled: boolean = false;
  showPicker: boolean = false;

  @Output()
  resized = new EventEmitter();

  @Output()
  collapse = new EventEmitter();
  isNearBottom: boolean = true;

  constructor(private auth: AuthenticationService, private ref: ChangeDetectorRef, private lobbyService: LobbyService) {}

  ngOnInit(): void {
    this.user = this.auth.getUser();

    this.lobbyService.getChatHistory(this.lobby.id).subscribe((result) => {
      this.exisitingMessages = result;

      this.connection.on('postChat', (id: number, name: string, message: string, userId: number, lobbyId: number) => {
        if (lobbyId === this.lobby.id) {
          this.messages.push(new ChatViewModel(id, name, message, userId));
          this.ref.detectChanges();
          this.scrollToBottom(userId !== this.user.id);
        }
      });

      this.initialized = true;
      this.scrollToBottom(false);
    });
  }

  public sendMessage() {
    this.connection.invoke('postChat', this.user.firstName + ' ' + this.user.lastName, this.chatMessage, this.user.id, this.lobby.id);
    this.chatMessage = null;

  }

  onScroll(event) {
    this.isNearBottom = this.isUserNearBottom();
  }

  private isUserNearBottom(): boolean {
    const threshold = 50;
    const position = this.messageContainer.nativeElement.scrollTop + this.messageContainer.nativeElement.offsetHeight;
    const height = this.messageContainer.nativeElement.scrollHeight;
    return position > height - threshold;
  }

  handleSelection(char) {
    if (this.chatMessage == null) {
      this.chatMessage = '';
    }

    this.chatMessage = this.chatMessage + char;
    this.toggled = false;
    this.chatbox.nativeElement.focus();
  }

  public scrollToBottom(check: boolean): void {
    of(null)
      .pipe(delay(100))
      .subscribe((result) => {
        try {
          if (this.isNearBottom || !check) {
            this.messageContainer.nativeElement.scroll({
              top: this.messageContainer.nativeElement.scrollHeight,
              left: 0,
              behavior: 'smooth',
            });
            this.isNearBottom = true;
          }
        } catch (err) {}
      });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    let windowHeight = window.innerHeight;
    let messageHeight = this.messageContainer.nativeElement.getBoundingClientRect().top;

    this.messageContainer.nativeElement.style.height = windowHeight - messageHeight - 58 + 'px';
    this.resized.emit();
  }

  collapseChat() {
    this.collapse.emit();
  }
}
